<template>
	<v-row class="bg-transparent p-absolute ma-0 my-2 pa-0 px-0 saldo__text full-width d-flex flex-nowrap"
	       style="bottom: 0; z-index: 3">
		<v-container class="ma-0 pa-0 pr-2 d-flex justify-end align-center" style="max-width: 160px; min-width: 160px">
			Saldo de animais
		</v-container>
		<v-col class="ma-0 pa-0  d-flex flex-column justify-center align-center"
		       v-for="(_, idx) in listaDatas" :key="idx" style="min-width: 162px; max-width: 400px">
			<div>
				<span class="text-datas-number">
			{{
				calcularSaldoLote(
						crechario[`qtMachosDia${idx + 1}`],
						crechario[`qtFemeasDia${idx + 1}`]
				)
			}}
				</span>
			</div>
		</v-col>
		<v-container style="width: 20px" />
	</v-row>
</template>

<script>
import {mapState} from "vuex";

export default {
	name: 'SaldoDisponibilidadeCrechario',
	props: {
		crechario: {},
		listaDatas: {},
		showCheckIcon: {},
	},
	methods: {
		calcularSaldoLote(val1, val2) {
			val1 = !val1 || val1 < 1 ? 0 : parseFloat(val1)
			val2 = !val2 || val2 < 1 ? 0 : parseFloat(val2)
			return _.sum([val1, val2])
		},
	},
}
</script>